import registrationTranslation from './index.json';

export default registrationTranslation;
